import LegalLayout from "./LegalLayout";

export default function AGB() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Allgemeine Geschäftsbedingungen">
      <p className="!text-sm !text-zinc-500">
        Stand: Februar 2026. Anbieter: Erik Schrum (Norrbyte), Langenkamp 18,
        23743 Grömitz, Deutschland. Im Folgenden „Anbieter" oder „wir".
      </p>

      <h2>§ 1 Geltungsbereich</h2>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für
        sämtliche Verträge, die zwischen dem Anbieter und einem Nutzer
        („Kunde") über die Nutzung der Web-Anwendung{" "}
        <strong>PromptKiste AI</strong> (erreichbar unter der jeweils
        veröffentlichten Domain) geschlossen werden, einschließlich
        kostenpflichtiger Pläne („Pro", „Business"). Abweichende Bedingungen
        des Kunden werden nicht anerkannt, es sei denn, der Anbieter stimmt
        ihrer Geltung ausdrücklich schriftlich zu.
      </p>

      <h2>§ 2 Vertragspartner & Reseller</h2>
      <p>
        Anbieter und Vertragspartner für die <strong>kostenfreie Nutzung</strong>{" "}
        ist Erik Schrum (Norrbyte). Für <strong>kostenpflichtige Pläne</strong>{" "}
        tritt die{" "}
        <a
          href="https://www.digistore24.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Digistore24 GmbH
        </a>
        , St.-Godehard-Straße 32, 31139 Hildesheim, als Wiederverkäufer
        („Reseller") auf. Vertragspartner des Kunden in Bezug auf den Kauf,
        die Zahlung und die Rechnungsstellung ist somit Digistore24. Mit
        Abschluss des Kaufs gelten ergänzend die AGB von Digistore24:{" "}
        <a
          href="https://www.digistore24.com/page/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          digistore24.com/page/terms
        </a>
        .
      </p>

      <h2>§ 3 Vertragsschluss</h2>
      <p>
        Die Darstellung der Pläne und Preise im Tool stellt kein rechtlich
        bindendes Angebot dar, sondern eine Aufforderung zur Abgabe eines
        Angebots. Mit Klick auf „Jetzt kaufen" wird der Kunde zu Digistore24
        weitergeleitet. Der Vertrag kommt mit verbindlicher Bestellung über
        Digistore24 und der dortigen Auftragsbestätigung zustande. Die
        kostenfreie Nutzung erfordert keinen ausdrücklichen Vertragsschluss;
        sie kommt durch tatsächliche Inanspruchnahme zustande.
      </p>

      <h2>§ 4 Leistungen</h2>
      <h3>4.1 Free-Plan</h3>
      <p>
        Bis zu 3 Prompt-Generierungen pro Kalendertag, Standardqualität,
        Copy- & Download-Funktion. Keine Registrierung erforderlich. Der
        Anbieter behält sich vor, Free-Limits jederzeit anzupassen oder
        einzustellen.
      </p>

      <h3>4.2 Pro-Plan (9,99 € / Monat brutto)</h3>
      <p>
        Unbegrenzte Generierungen, detailliertere Prompts, Genre-Mix-Funktion,
        TikTok-Hook-Ideen, priorisierte Generierung. Aktivierung erfolgt nach
        erfolgreicher Bestellung über Digistore24.
      </p>

      <h3>4.3 Business-Plan (29 € / Monat brutto)</h3>
      <p>
        Alle Pro-Funktionen, Team-Nutzung (bis zu 5 Sitze), Prompt-Historie,
        Export-Funktionen (CSV, JSON), zukünftige API-Features. Aktivierung
        wie bei Pro.
      </p>

      <h3>4.4 Demo-Charakter & geistiges Eigentum an Prompts</h3>
      <p>
        Die generierten Prompts sind algorithmisch erzeugte Textbausteine.
        Der Anbieter erhebt an den Ergebnis-Prompts keine eigenen
        Urheberrechte. Der Kunde darf die Ergebnisse unbeschränkt
        weiterverwenden. Eine Garantie, dass die Prompts in Drittsystemen
        (z. B. Suno AI) ein bestimmtes Ergebnis liefern, wird nicht
        übernommen.
      </p>

      <h2>§ 5 Preise & Zahlung</h2>
      <p>
        Alle Preise verstehen sich als Bruttopreise inkl. der gesetzlichen
        Umsatzsteuer. Die Abbuchung und Rechnungsstellung erfolgt
        ausschließlich durch <strong>Digistore24.com</strong>. Verfügbare
        Zahlungsmethoden, Fälligkeiten und Belegversand richten sich nach den
        Angaben und Bedingungen von Digistore24.
      </p>

      <h2>§ 6 Laufzeit & Kündigung</h2>
      <p>
        Pro und Business werden als monatliches Abonnement angeboten und
        verlängern sich automatisch um den jeweiligen Bezugszeitraum, sofern
        nicht vor Ablauf gekündigt wird. Kündigungen erfolgen direkt im
        Kunden­konto von Digistore24 (
        <a
          href="https://www.digistore24.com/customer"
          target="_blank"
          rel="noopener noreferrer"
        >
          digistore24.com/customer
        </a>
        ). Der Free-Plan ist jederzeit ohne Kündigung beendbar (einfach nicht
        weiter nutzen / lokale Browser-Daten löschen).
      </p>

      <h2>§ 7 Widerrufsrecht für Verbraucher</h2>
      <p>
        Verbrauchern steht grundsätzlich ein 14-tägiges Widerrufsrecht zu.{" "}
        <strong>
          Bei digitalen Inhalten, die nicht auf einem körperlichen Datenträger
          geliefert werden, erlischt das Widerrufsrecht jedoch, wenn der
          Anbieter mit der Vertragsausführung begonnen hat, nachdem der
          Verbraucher ausdrücklich zugestimmt hat, dass mit der Ausführung
          vor Ablauf der Widerrufsfrist begonnen wird, und er bestätigt hat,
          dass sein Widerrufsrecht damit erlischt
        </strong>{" "}
        (§ 356 Abs. 5 BGB). Diese Zustimmung wird üblicherweise im Checkout
        von Digistore24 eingeholt. Im Übrigen gilt die Widerrufsbelehrung,
        die dem Kunden im Bestellprozess durch Digistore24 angezeigt wird.
      </p>

      <h2>§ 8 Verfügbarkeit & Wartung</h2>
      <p>
        Der Anbieter ist bemüht, eine möglichst hohe Verfügbarkeit der App
        sicherzustellen, garantiert jedoch keine ununterbrochene
        Erreichbarkeit. Kurzfristige Ausfälle wegen Wartung, Updates oder
        technischer Störungen Dritter (z. B. Hosting-Provider) sind möglich
        und begründen keine Minderungs- oder Ersatzansprüche.
      </p>

      <h2>§ 9 Pflichten des Kunden</h2>
      <p>
        Der Kunde verpflichtet sich, die App ausschließlich im Rahmen
        geltender Gesetze zu nutzen. Eine missbräuchliche Nutzung — etwa
        automatisiertes Auslesen, Umgehung des Tageslimits durch technische
        Manipulation, Reverse-Engineering oder die Erstellung diskriminierender,
        gewaltverherrlichender oder anderweitig rechtswidriger Inhalte — ist
        untersagt. Der Anbieter darf bei Verstößen den Zugang zur App ohne
        Vorankündigung einschränken oder sperren.
      </p>

      <h2>§ 10 Gewährleistung & Haftung</h2>
      <p>
        Der Anbieter haftet uneingeschränkt für Schäden aus Verletzung des
        Lebens, des Körpers oder der Gesundheit sowie bei Vorsatz und grober
        Fahrlässigkeit. Bei einfacher Fahrlässigkeit haftet der Anbieter nur
        bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) und
        beschränkt auf den vertragstypischen, vorhersehbaren Schaden. Die
        Haftung für mittelbare Schäden, Folgeschäden und entgangenen Gewinn
        ist im gesetzlich zulässigen Rahmen ausgeschlossen.
      </p>

      <h2>§ 11 Datenschutz</h2>
      <p>
        Es gilt unsere{" "}
        <a href="/datenschutz">Datenschutzerklärung</a>. Die App speichert
        nur technisch notwendige Daten im localStorage des Browsers und nutzt
        keine Tracking-Cookies. Zahlungsdaten werden ausschließlich von
        Digistore24 verarbeitet.
      </p>

      <h2>§ 12 Schlussbestimmungen</h2>
      <p>
        Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
        UN-Kaufrechts. Erfüllungsort und — soweit gesetzlich zulässig —
        Gerichtsstand ist Grömitz, Schleswig-Holstein. Sollten einzelne
        Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die
        Wirksamkeit der übrigen Bestimmungen unberührt. Anstelle der
        unwirksamen Bestimmung gilt diejenige wirksame Regelung, die dem
        wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
      </p>

      <h2>§ 13 Streitbeilegung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        . Wir sind nicht bereit oder verpflichtet, an
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </p>

      <p className="!text-sm !text-zinc-500">
        Kontakt für Fragen zu diesen AGB:{" "}
        <a href="mailto:info@norrbyte.de">info@norrbyte.de</a>.
      </p>
    </LegalLayout>
  );
}
